import React, { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import {
    Box, Tooltip, IconButton, Checkbox, FormControlLabel, Grid, Skeleton, Chip, Menu, MenuItem,
    Dialog, DialogContent, Stack, useMediaQuery, useTheme,
    Card, CardContent, Typography, Pagination, Divider
} from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckIcon from '@mui/icons-material/Check';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchIcon from '@mui/icons-material/Search';

import SNARonda from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/RondaVirtual/snaRonda';
import api from '../../../../../services/api';

const Tarefas = ({ darkMode, themeHelper, handleClickEdicao }) => {
    const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);
    const [tarefas, setTarefas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRegistrosTarefas, setTotalRegistrosTarefas] = useState(0);
    const [filtroMinhasTarefasChecked, setFiltroMinhasTarefasChecked] = useState(() => {
        const cookie = Cookies.get("filtro_minhas_tarefas");
        return cookie ? cookie === "true" : true;
    });
    const [paginationTarefas, setPaginationTarefas] = useState({
        pageIndex: 0,
        pageSize: 100,
    });
    const [filtro, setFiltro] = useState("");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [openSnaRondaVirtual, setOpenSnaRondaVirtual] = useState(false);
    const [rondaVirtualSnaId, setRondaVirtualSnaId] = useState(null);

    const handleOpenSnaRondaVirtual = (id) => {
        setRondaVirtualSnaId(id);
        setOpenSnaRondaVirtual(true);
    };

    const handleCloseSnaRondaVirtual = () => {
        setOpenSnaRondaVirtual(false);
        setRondaVirtualSnaId(null);
    };

    const canExecute = (item) => {
        if (id_usuario_logado === 1) return true; // Admin
        if (item.usuario_executor) {
            return parseInt(item.usuario_executor.id_usuario, 10) === id_usuario_logado;
        }
        return parseInt(item.os_analista_id, 10) === id_usuario_logado;
    };

    const handleIniciar = async (item) => {
        if (!canExecute(item)) {
            alert("Somente o Analista ou o Usuário designado pode executar esta ação!");
            return;
        }
        const resposta = window.confirm("Sinalizar inicio da execução do procedimento?");
        if (resposta) {
            try {
                const id_proc = item.id_procedimento_execucao;
                const id_ordem = item.id_ordem_servico;
                const cadastro = { usuario_criador: { id_usuario: id_usuario_logado } };
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                await api.put(`/v1/protected/ordemservico/iniciarprocedimento/${id_proc}/${id_ordem}`, cadastro, { headers });
                alert("Procedimento foi sinalizado como iniciado!");
                listarTarefas();
            } catch (err) {
                console.error(err);
                alert("Erro ao iniciar o procedimento.");
            }
        }
    };

    const handleExecutar = (item) => {
        if (!canExecute(item)) {
            alert("Somente o Analista ou o Usuário designado pode executar esta ação!");
            return;
        }
        window.open(`/gestao/administracao/ordensdeservicos/atualizarprocedimentoexecucao/${item.id_procedimento_execucao}/ordemservico/${item.id_ordem_servico}/2/0`, "_blank");
    };

    const handleVisualizar = (item) => {
        window.open(`/gestao/administracao/ordensdeservicos/vizualizarprocedimentoexecucao/${item.id_procedimento_execucao}/ordemservico/${item.id_ordem_servico}`, "_blank");
    };

    const handleFiltroMinhasTarefasChecked = (isChecked) => {
        setFiltroMinhasTarefasChecked(isChecked);
        Cookies.set("filtro_minhas_tarefas", isChecked.toString(), { expires: 120 });
        setPaginationTarefas({ pageIndex: 0, pageSize: paginationTarefas.pageSize });
    };

    const returnDescricaoInstalacao = (instalacao) => {
        if (!instalacao) return "";
        let obj = instalacao;
        if (typeof obj === 'string') {
            try {
                obj = JSON.parse(instalacao);
            } catch (e) {
                return instalacao;
            }
        }
        return obj.nome_fantasia || obj.nome_empresarial || obj.nome_mapa || obj.nome || "";
    };

    const TaskCard = ({ item }) => {
        const statusColor = item.data_hora_cancelamento ? (darkMode ? "#4d3a00" : "#fff3cd")
            : item.status === 1 ? (darkMode ? "#1b5e20" : "#e8f5e9")
                : item.data_hora_inicio_execucao ? (darkMode ? "#0d47a1" : "#e3f2fd")
                    : (darkMode ? "#424242" : "#f5f5f5");

        const statusLabel = item.data_hora_cancelamento ? "Cancelado"
            : item.status === 1 ? (item.resultado === 1 ? "Sucesso" : "Falha")
                : item.data_hora_inicio_execucao ? "Executando"
                    : "Pendente";

        return (
            <Card sx={{
                mb: 2,
                backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                color: themeHelper.text,
                borderRadius: '12px',
                boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.1)',
                borderLeft: `6px solid ${item.data_hora_cancelamento ? '#ff9800' : item.status === 1 ? '#4caf50' : '#2196f3'}`,
                overflow: 'hidden',
                maxWidth: '100%',
                boxSizing: 'border-box'
            }}>
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5, gap: 1 }}>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography variant="subtitle2" sx={{
                                fontWeight: 600,
                                color: darkMode ? '#90caf9' : '#1565c0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                wordBreak: 'break-word'
                            }}>
                                <AssignmentIcon fontSize="inherit" /> #{item.id_ordem_servico} - {item.nome_solicitacao || 'Sem Título'}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 500, mt: 0.5, wordBreak: 'break-word' }}>
                                {item.nome_procedimento}
                            </Typography>
                        </Box>
                        <IconButton size="small" onClick={() => handleClickEdicao(item)} sx={{ color: 'green', flexShrink: 0 }}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    <Divider sx={{ my: 1.5, opacity: 0.5 }} />

                    <Stack spacing={1.5}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <BusinessIcon sx={{ fontSize: 18, color: themeHelper.textSecondary, flexShrink: 0 }} />
                            <Typography variant="body2" sx={{ fontSize: '0.85rem', wordBreak: 'break-word' }}>
                                {returnDescricaoInstalacao(item.instalacao) || item.instalacao_nome || 'Instalação não informada'}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <AccessTimeIcon sx={{ fontSize: 18, color: themeHelper.textSecondary, flexShrink: 0 }} />
                            <Typography variant="body2" sx={{ fontSize: '0.85rem', color: themeHelper.textSecondary }}>
                                {formatarTempoDecorrido(item.data_hora_criacao)}
                            </Typography>
                            <Chip
                                label={statusLabel}
                                size="small"
                                sx={{
                                    height: 20,
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    backgroundColor: statusColor,
                                    color: item.status === 1 ? (item.resultado === 1 ? '#2e7d32' : '#c62828') : themeHelper.text
                                }}
                            />
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PersonIcon sx={{ fontSize: 18, color: themeHelper.textSecondary, flexShrink: 0 }} />
                            <Typography variant="caption" sx={{ color: themeHelper.textSecondary, wordBreak: 'break-word' }}>
                                Cr: <Box component="span" sx={{ fontWeight: 600, color: themeHelper.text }}>{item.usuario_criador?.nome_amigavel || '—'}</Box> | Ex: <Box component="span" sx={{ fontWeight: 600, color: themeHelper.text }}>{item.usuario_executor?.nome_amigavel || '—'}</Box>
                            </Typography>
                        </Box>
                    </Stack>

                    <Box sx={{ mt: 2, pt: 2, borderTop: `1px dashed ${darkMode ? '#444' : '#ddd'}`, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {item.data_hora_inicio_execucao === null && item.status === 0 && (
                            <Chip
                                icon={<PlayArrowIcon style={{ color: '#fff' }} />}
                                label="Iniciar"
                                onClick={() => handleIniciar(item)}
                                clickable
                                sx={{ backgroundColor: '#4caf50', color: '#fff', '&:hover': { backgroundColor: '#43a047' } }}
                            />
                        )}
                        {item.status === 0 && item.data_hora_inicio_execucao !== null && (
                            <Chip
                                icon={<RefreshIcon style={{ color: '#fff' }} />}
                                label="Executar"
                                onClick={() => handleExecutar(item)}
                                clickable
                                sx={{ backgroundColor: '#2196f3', color: '#fff', '&:hover': { backgroundColor: '#1e88e5' } }}
                            />
                        )}
                        {item.status === 1 && item.data_hora_fim_execucao !== null && (
                            <Chip
                                icon={<VisibilityIcon style={{ color: '#fff' }} />}
                                label="Visualizar"
                                onClick={() => handleVisualizar(item)}
                                clickable
                                sx={{ backgroundColor: '#9e9e9e', color: '#fff', '&:hover': { backgroundColor: '#757575' } }}
                            />
                        )}
                        {item.id_ronda_virtual > 0 && (
                            <Chip
                                label={`Ronda #${item.id_ronda_virtual}`}
                                onClick={() => window.open(`/gestao/operacional/rondavirtual/gerenciar/${item.id_ronda_virtual}`, '_blank')}
                                clickable
                                variant="outlined"
                                color="primary"
                            />
                        )}
                    </Box>
                </CardContent>
            </Card>
        );
    };

    const TextoComTooltip = ({ text, max = 25 }) => {
        if (!text) return "—";
        const curta = text.length > max ? text.substring(0, max) + "..." : text;
        return (
            <Tooltip title={isMobile ? "" : text}>
                <span
                    style={{
                        display: 'inline-block',
                        width: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 12,
                        color: themeHelper.text,
                        cursor: 'default'
                    }}
                >
                    {curta}
                </span>
            </Tooltip>
        );
    };

    const formatarTempoDecorrido = (dataInicial, prefixo = "Criado") => {
        if (!dataInicial) return "";
        const inicio = new Date(dataInicial);
        const agora = new Date();
        const diffMs = agora - inicio;

        // Se for uma data futura
        if (diffMs < 0) {
            const horasFaltando = Math.abs(Math.floor(diffMs / (1000 * 60 * 60)));
            const diasFaltando = Math.floor(horasFaltando / 24);
            if (diasFaltando >= 1) return `Agendado para daqui a ${diasFaltando} dia${diasFaltando > 1 ? "s" : ""}`;
            if (horasFaltando >= 1) return `Agendado para daqui a ${horasFaltando} hora${horasFaltando > 1 ? "s" : ""}`;
            return "Agendado para menos de 1 hora";
        }

        const horas = Math.floor(diffMs / (1000 * 60 * 60));
        const dias = Math.floor(horas / 24);

        if (dias >= 1) return `${prefixo} há ${dias} dia${dias > 1 ? "s" : ""}`;
        if (horas >= 1) return `${prefixo} há ${horas} hora${horas > 1 ? "s" : ""}`;
        return `${prefixo} há menos de 1 hora`;
    };

    const formatarDuracaoExecucao = (inicio, fim) => {
        if (!inicio || !fim) return "";
        const i = new Date(inicio);
        const f = new Date(fim);
        let diff = (f - i) / 1000;
        const h = Math.floor(diff / 3600);
        diff %= 3600;
        const m = Math.floor(diff / 60);
        const s = Math.floor(diff % 60);
        return `${h}h ${m}m ${s}s`;
    };

    async function listarTarefas() {
        setLoading(true);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };
            const regra = Cookies.get('regra');

            if (regra.includes("ADMIN")) {
                const response2 = await api.get(
                    `v1/protected/ordemservico/listartodossimples?busca=${filtro}&size=${paginationTarefas.pageSize}&page=${paginationTarefas.pageIndex}&sort=id_ordem_servico,desc`,
                    { headers }
                );

                const dadosOriginais = response2.data.dados;
                const totalOs = response2.data.totalRegistros;

                const listaTarefas = [];

                dadosOriginais.forEach(ordem => {
                    const procedimentos = Array.isArray(ordem.procedimentos)
                        ? ordem.procedimentos
                        : [];

                    procedimentos.forEach(proc => {
                        listaTarefas.push({
                            id_ordem_servico: ordem.id_ordem_servico,
                            os_usuario_criador: ordem.usuario_criador,
                            os_status_ordem: ordem.status_ordem,
                            os_analista_id: ordem.analista?.id_usuario,
                            id_ronda_virtual: ordem.id_ronda_virtual,
                            ronda_virtual_problemas: ordem.ronda_virtual_problemas,
                            id_procedimento_execucao: proc.id_procedimento_execucao,
                            nome_procedimento: proc.procedimento?.nome || "",
                            data_hora_criacao: proc.data_hora_criacao,
                            data_hora_criacao_os: ordem.data_hora_criacao,
                            data_hora_inicio_execucao: proc.data_hora_inicio_execucao,
                            data_hora_execucao: proc.data_hora_execucao,
                            usuario_criador: proc.usuario_criador,
                            usuario_executor: proc.usuario_executor,
                            descricao_solicitacao: ordem.descricao_solicitacao,
                            nome_solicitacao: ordem.nome_solicitacao,
                            instalacao: ordem.instalacao,
                            instalacao_nome: ordem.instalacao_nome,
                            status: proc.status,
                            resultado: proc.resultado,
                            observacoes: proc.observacoes,
                            duracao: proc.duracao,
                            data_hora_fim_execucao: proc.data_hora_fim_execucao,
                            data_hora_cancelamento: proc.data_hora_cancelamento,
                            mensagem_cancelamento: proc.mensagem_cancelamento,
                        });
                    });
                });

                let tarefasFiltradas = listaTarefas;

                if (filtroMinhasTarefasChecked) {
                    tarefasFiltradas = listaTarefas.filter(task => {
                        return (
                            parseInt(task.usuario_criador?.id_usuario || 0, 10) === id_usuario_logado ||
                            parseInt(task.usuario_executor?.id_usuario || 0, 10) === id_usuario_logado
                        );
                    });
                }

                setTarefas(tarefasFiltradas);
                setTotalRegistrosTarefas(totalOs);
            }
            else if (regra.includes("TEC")) {
                // Para técnicos: busca apenas OS onde o usuário tem envolvimento, depois filtra por procedimentos
                const response2 = await api.get(
                    `v1/protected/ordemservico/listartodossimples?busca=${filtro}&size=${paginationTarefas.pageSize}&page=${paginationTarefas.pageIndex}&sort=id_ordem_servico,desc&usuario_id=${id_usuario_logado}`,
                    { headers }
                );

                const dadosOriginais = response2.data.dados;
                const totalOs = response2.data.totalRegistros;

                const listaTarefas = [];

                dadosOriginais.forEach(ordem => {
                    const procedimentos = Array.isArray(ordem.procedimentos)
                        ? ordem.procedimentos
                        : [];

                    procedimentos.forEach(proc => {
                        // Para técnicos: só incluir procedimentos onde é criador ou executor
                        const eCriador = parseInt(proc.usuario_criador?.id_usuario || 0, 10) === id_usuario_logado;
                        const eExecutor = parseInt(proc.usuario_executor?.id_usuario || 0, 10) === id_usuario_logado;
                        if (!eCriador && !eExecutor) return;

                        listaTarefas.push({
                            id_ordem_servico: ordem.id_ordem_servico,
                            os_usuario_criador: ordem.usuario_criador,
                            os_status_ordem: ordem.status_ordem,
                            os_analista_id: ordem.analista?.id_usuario,
                            id_ronda_virtual: ordem.id_ronda_virtual,
                            ronda_virtual_problemas: ordem.ronda_virtual_problemas,
                            id_procedimento_execucao: proc.id_procedimento_execucao,
                            nome_procedimento: proc.procedimento?.nome || "",
                            data_hora_criacao: proc.data_hora_criacao,
                            data_hora_criacao_os: ordem.data_hora_criacao,
                            data_hora_inicio_execucao: proc.data_hora_inicio_execucao,
                            data_hora_execucao: proc.data_hora_execucao,
                            usuario_criador: proc.usuario_criador,
                            usuario_executor: proc.usuario_executor,
                            descricao_solicitacao: ordem.descricao_solicitacao,
                            nome_solicitacao: ordem.nome_solicitacao,
                            instalacao: ordem.instalacao,
                            instalacao_nome: ordem.instalacao_nome,
                            status: proc.status,
                            resultado: proc.resultado,
                            observacoes: proc.observacoes,
                            duracao: proc.duracao,
                            data_hora_fim_execucao: proc.data_hora_fim_execucao,
                            data_hora_cancelamento: proc.data_hora_cancelamento,
                            mensagem_cancelamento: proc.mensagem_cancelamento,
                        });
                    });
                });

                setTarefas(listaTarefas);
                setTotalRegistrosTarefas(totalOs);

            }

        } catch (err) {
            console.error("Erro ao listar tarefas:", err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        listarTarefas();
    }, [paginationTarefas, filtroMinhasTarefasChecked, filtro]);

    const columnsTarefas = useMemo(
        () => [
            {
                id: 'id_ordem',
                header: 'ID',
                size: 180,
                accessorFn: row => row.id_ordem_servico,
                Cell: ({ row, renderedCellValue }) => {
                    const item = row.original;

                    const openOS = () => {
                        window.open(`/gestao/administracao/ordensdeservicos/editar/${item.id_ordem_servico}`, '_blank');
                    };

                    const getNomeEtapa = (statusId) => {
                        const etapas = {
                            0: "Aberta",
                            1: "Tratamento Remoto",
                            2: "Analise Previa",
                            3: "Tratamento em Campo",
                            9: "Concluida"
                        };
                        return etapas[statusId] ?? "N/A";
                    };

                    const nomeEtapa = getNomeEtapa(item.os_status_ordem);

                    return (
                        <Tooltip
                            interactive
                            title={
                                <Box sx={{ p: 1, fontSize: '13px' }}>
                                    <div style={{ marginBottom: '8px' }}>
                                        <strong>Ordem de Serviço</strong><br />
                                        Criado por: {item.os_usuario_criador?.nome_amigavel || item.os_usuario_criador?.nome || "Desconhecido"}<br />
                                        Data: {item.data_hora_criacao ? new Date(item.data_hora_criacao).toLocaleString("pt-BR") : "—"}<br />
                                        Etapa Atual: {nomeEtapa}
                                    </div>
                                    <div style={{ marginBottom: '8px' }}>
                                        <strong>Solicitação:</strong><br />
                                        {item.nome_solicitacao || "—"}
                                    </div>
                                    <div style={{ marginBottom: '8px' }}>
                                        <strong>Descrição:</strong><br />
                                        {item.descricao_solicitacao || "—"}
                                    </div>
                                    {item.id_ronda_virtual > 0 && (
                                        <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                                            <div style={{ color: '#ffb74d', fontWeight: 'bold', marginBottom: '4px' }}>Ronda Virtual #{item.id_ronda_virtual}</div>
                                            <div style={{ fontSize: '12px', fontStyle: 'italic', marginBottom: '8px' }}>
                                                Problemas: {item.ronda_virtual_problemas || "Nenhum problema registrado"}
                                            </div>
                                            <Stack direction="row" spacing={1}>
                                                <Chip
                                                    label="Gerenciar Ronda"
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        window.open(`/gestao/operacional/rondavirtual/gerenciar/${item.id_ronda_virtual}`, '_blank');
                                                    }}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        backgroundColor: '#1976d2',
                                                        color: '#fff',
                                                        '&:hover': { backgroundColor: '#1565c0' }
                                                    }}
                                                />
                                                <Chip
                                                    label="Resumo RV"
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleOpenSnaRondaVirtual(item.id_ronda_virtual);
                                                    }}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        backgroundColor: '#ff9800',
                                                        color: '#fff',
                                                        '&:hover': { backgroundColor: '#f57c00' }
                                                    }}
                                                />
                                            </Stack>
                                        </Box>
                                    )}
                                </Box>
                            }>
                            <span
                                onClick={openOS}
                                style={{
                                    cursor: 'pointer',
                                    color: darkMode ? '#90caf9' : '#1976d2',
                                    fontWeight: 'bold',
                                    textDecoration: 'underline'
                                }}
                            >
                                #{renderedCellValue} {isMobile ? '' : `- ${nomeEtapa}`}
                            </span>
                        </Tooltip>
                    );
                }
            },
            {
                header: 'Tarefa',
                id: 'nome_procedimento',
                size: 200,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => row.nome_procedimento,
                Cell: ({ row, renderedCellValue }) => {
                    const item = row.original;
                    const id_proc = item.id_procedimento_execucao;
                    const id_ordem = item.id_ordem_servico;
                    const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);

                    const [anchorEl, setAnchorEl] = useState(null);
                    const open = Boolean(anchorEl);
                    const handleClickMenu = (event) => {
                        event.stopPropagation();
                        setAnchorEl(event.currentTarget);
                    };
                    const handleCloseMenu = (event) => {
                        if (event) event.stopPropagation();
                        setAnchorEl(null);
                    };

                    const handleIniciarProc = (event) => {
                        handleCloseMenu(event);
                        handleIniciar(item);
                    };

                    const handleExecutarProc = (event) => {
                        handleCloseMenu(event);
                        handleExecutar(item);
                    };

                    const handleVisualizarProc = (event) => {
                        handleCloseMenu(event);
                        handleVisualizar(item);
                    };

                    // Redirecionamento padrão ao clicar no Chip (mantive a lógica anterior)
                    const handleOpenDefault = () => {
                        let url;
                        if (!item.data_hora_inicio_execucao) {
                            url = "/gestao/administracao/ordensdeservicos/editar/" + id_ordem;
                        } else if (item.data_hora_cancelamento) {
                            url = "/gestao/administracao/ordensdeservicos/vizualizarprocedimentoexecucao/" + id_proc + "/ordemservico/" + id_ordem;
                        } else if (item.status !== 1) {
                            url = "/gestao/administracao/ordensdeservicos/atualizarprocedimentoexecucao/" + id_proc + "/ordemservico/" + id_ordem + "/2/0";
                        } else {
                            url = "/gestao/administracao/ordensdeservicos/vizualizarprocedimentoexecucao/" + id_proc + "/ordemservico/" + id_ordem;
                        }
                        window.open(url, "_blank");
                    };

                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Tooltip title={renderedCellValue}>
                                <Chip
                                    label={renderedCellValue}
                                    onClick={handleOpenDefault}
                                    sx={{
                                        backgroundColor: darkMode ? '#003366' : "#e3f2fd",
                                        color: darkMode ? '#bbdefb' : "#0d47a1",
                                        fontSize: "0.75rem",
                                        padding: "2px 4px",
                                        borderRadius: "8px",
                                        maxWidth: "160px",
                                        border: darkMode ? '1px solid #1976d2' : 'none',
                                        cursor: 'pointer',
                                        '&:hover': { opacity: 0.8 }
                                    }}
                                />
                            </Tooltip>

                            <IconButton
                                size="small"
                                onClick={handleClickMenu}
                                sx={{ color: themeHelper.textSecondary }}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseMenu}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {item.data_hora_inicio_execucao === null && item.status === 0 && (
                                    <MenuItem onClick={handleIniciarProc}>
                                        <PlayArrowIcon fontSize="small" sx={{ mr: 1, color: '#4caf50' }} />
                                        Iniciar
                                    </MenuItem>
                                )}
                                {item.status === 0 && item.data_hora_inicio_execucao !== null && (
                                    <MenuItem onClick={handleExecutarProc}>
                                        <RefreshIcon fontSize="small" sx={{ mr: 1, color: '#2196f3' }} />
                                        Executar
                                    </MenuItem>
                                )}
                                {item.status === 1 && item.data_hora_fim_execucao !== null && (
                                    <MenuItem onClick={handleVisualizarProc}>
                                        <VisibilityIcon fontSize="small" sx={{ mr: 1, color: '#9e9e9e' }} />
                                        Vizualizar
                                    </MenuItem>
                                )}
                            </Menu>
                        </Box>
                    );
                },
            },
            {
                header: 'Instalação',
                size: 150,
                id: 'instalacao',
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => returnDescricaoInstalacao(row.instalacao) || row.instalacao_nome || "",
                Cell: ({ renderedCellValue }) => (
                    <TextoComTooltip text={renderedCellValue} max={25} />
                ),
            },
            {
                header: 'Tempo',
                id: 'tempo_decorrido',
                size: 200,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => row,
                Cell: ({ row }) => {
                    const item = row.original;
                    let tempoContent = null;

                    if (item.data_hora_cancelamento) {
                        tempoContent = (
                            <span style={{ fontSize: 12, color: darkMode ? "#ffb74d" : "#e65100" }}>
                                Cancelado em {new Date(item.data_hora_cancelamento).toLocaleString("pt-BR")}
                            </span>
                        );
                    } else if (item.status === 0) {
                        tempoContent = (
                            <span style={{ fontSize: 12, color: darkMode ? "#ef9a9a" : "#d32f2f" }}>
                                {formatarTempoDecorrido(item.data_hora_execucao, "Agendado")}
                            </span>
                        );
                    } else {
                        tempoContent = (
                            <span style={{ fontSize: 12, color: darkMode ? "#a5d6a7" : "#2e7d32" }}>
                                {item.data_hora_inicio_execucao ? new Date(item.data_hora_inicio_execucao).toLocaleString("pt-BR") : ""}
                                {" → "}
                                {item.data_hora_fim_execucao ? new Date(item.data_hora_fim_execucao).toLocaleString("pt-BR") : ""}
                                <br />
                                {formatarDuracaoExecucao(item.data_hora_inicio_execucao, item.data_hora_fim_execucao)}
                            </span>
                        );
                    }

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span style={{ fontSize: 12, color: themeHelper.text }}>
                                Criado em: {item.data_hora_criacao ? new Date(item.data_hora_criacao).toLocaleString("pt-BR") : "—"}
                            </span>
                            <span style={{ fontSize: 12, color: themeHelper.text }}>
                                {item.status === 1 ? "Executado em:" : "Execução em:"} {item.data_hora_execucao ? new Date(item.data_hora_execucao).toLocaleString("pt-BR") : "—"}
                            </span>
                            {tempoContent}
                        </div>
                    );
                },
            },
            {
                header: 'Status',
                id: 'status',
                size: 250,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => row.status,
                muiTableBodyCellProps: ({ row }) => {
                    const item = row.original;
                    let cor = darkMode ? "#333333" : "#eeeeee";
                    if (item.data_hora_cancelamento) cor = darkMode ? "#4d3a00" : "#fff3cd";
                    else if (item.status === 1 && item.resultado === 1) cor = darkMode ? "#1b5e20" : "#d0f8ce";
                    else if (item.status === 1 && item.resultado === 0) cor = darkMode ? "#b71c1c" : "#ffebee";
                    return {
                        sx: {
                            backgroundColor: cor,
                            color: themeHelper.text,
                            fontWeight: "bold",
                        }
                    };
                },
                Cell: ({ row }) => {
                    const item = row.original;

                    const tooltipText = item.data_hora_cancelamento
                        ? `Cancelado: ${item.mensagem_cancelamento}`
                        : (item.observacoes ? `Observações: ${item.observacoes}` : "");

                    return (
                        <Tooltip title={isMobile ? "" : tooltipText}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                                {item.data_hora_cancelamento ? (
                                    <Chip
                                        icon={<HighlightOffIcon />}
                                        label="Cancelado"
                                        size="small"
                                        sx={{ backgroundColor: darkMode ? "#4d3a00" : "#fff3cd", color: darkMode ? "#ffb74d" : "#e65100", fontWeight: 'bold' }}
                                    />
                                ) : (
                                    <>
                                        {item.status === 1 ? (
                                            <Chip
                                                icon={<CheckCircleIcon />}
                                                label="Executado"
                                                size="small"
                                                sx={{ backgroundColor: darkMode ? "#1b5e20" : "#e8f5e9", color: darkMode ? "#a5d6a7" : "#2e7d32", fontWeight: 'bold' }}
                                            />
                                        ) : item.data_hora_inicio_execucao ? (
                                            <Chip
                                                icon={<RadioButtonUncheckedIcon />}
                                                label="Executando"
                                                size="small"
                                                sx={{ backgroundColor: darkMode ? "#0d47a1" : "#e3f2fd", color: darkMode ? "#90caf9" : "#1976d2", fontWeight: 'bold' }}
                                            />
                                        ) : (
                                            <Chip
                                                icon={<RadioButtonUncheckedIcon />}
                                                label="Não executado"
                                                size="small"
                                                sx={{ backgroundColor: darkMode ? "#424242" : "#f5f5f5", color: themeHelper.text, fontWeight: 'bold' }}
                                            />
                                        )}
                                        {item.status === 1 && (
                                            <Chip
                                                icon={item.resultado === 1 ? <CheckIcon /> : <HighlightOffIcon />}
                                                label={item.resultado === 1 ? "Sucesso" : "Falha"}
                                                size="small"
                                                sx={{
                                                    backgroundColor: item.resultado === 1 ? (darkMode ? "#1b5e20" : "#e8f5e9") : (darkMode ? "#b71c1c" : "#ffebee"),
                                                    color: item.resultado === 1 ? (darkMode ? "#a5d6a7" : "#2e7d32") : (darkMode ? "#ef9a9a" : "#c62828"),
                                                    fontWeight: 'bold'
                                                }}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </Tooltip>
                    );
                },
            },

            {
                id: 'envolvidos',
                header: 'As partes',
                size: 250,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => ({
                    criador: row.usuario_criador?.nome_amigavel || '',
                    executor: row.usuario_executor?.nome_amigavel || ''
                }),
                Cell: ({ row }) => {
                    const item = row.original;
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span style={{ fontSize: 12, color: themeHelper.text }}>
                                Criador: <span style={{ color: themeHelper.text, fontWeight: 600 }}>{item.usuario_criador?.nome_amigavel}</span><br />
                                Executor: <span style={{ color: themeHelper.text, fontWeight: 600 }}>{item.usuario_executor?.nome_amigavel}</span><br />
                            </span>
                        </Box>
                    );
                },
            },
        ],
        [darkMode, themeHelper, handleOpenSnaRondaVirtual]
    );

    return (
        <div style={{ paddingTop: 5, width: '100%', boxSizing: 'border-box' }}>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid container direction="row" justifyContent={isMobile ? "center" : "flex-end"} alignItems="center" item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filtroMinhasTarefasChecked}
                                onChange={(e) => handleFiltroMinhasTarefasChecked(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Minhas Tarefas"
                    />
                </Grid>
            </Grid>
            {loading ? (
                <Skeleton animation={"wave"} width={'100%'} height={400} sx={{ mt: 2, borderRadius: '12px' }} />
            ) : (
                <Box sx={{ mt: 2 }}>
                    {isMobile ? (
                        <Box sx={{ pb: 4 }}>
                            {tarefas.length > 0 ? (
                                <>
                                    {tarefas.map((item) => (
                                        <TaskCard key={`${item.id_ordem_servico}-${item.id_procedimento_execucao}`} item={item} />
                                    ))}
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 2 }}>
                                        <Pagination
                                            count={Math.ceil(totalRegistrosTarefas / paginationTarefas.pageSize)}
                                            page={paginationTarefas.pageIndex + 1}
                                            onChange={(e, v) => setPaginationTarefas(prev => ({ ...prev, pageIndex: v - 1 }))}
                                            color="primary"
                                            size="small"
                                        />
                                    </Box>
                                </>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 8, opacity: 0.6 }}>
                                    <SearchIcon sx={{ fontSize: 48, mb: 2 }} />
                                    <Typography variant="body1">Nenhuma tarefa encontrada.</Typography>
                                </Box>
                            )}
                        </Box>
                    ) : (
                        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                            <MaterialReactTable
                                columns={columnsTarefas}
                                data={tarefas}
                                enableBottomToolbar
                                enableGlobalFilterModes={false}
                                enableRowActions
                                manualPagination
                                state={{
                                    pagination: paginationTarefas,
                                    columnVisibility: {
                                        status: true,
                                        envolvidos: true,
                                        instalacao: true,
                                        tempo_decorrido: true
                                    }
                                }}
                                onPaginationChange={setPaginationTarefas}
                                rowCount={totalRegistrosTarefas}
                                enableStickyHeader
                                paginationDisplayMode="pages"
                                getRowId={(row) => row.id_ordem_servico + "-" + row.id_procedimento_execucao}
                                enableGrouping
                                enableFullScreenToggle
                                enableColumnResizing={false}
                                layoutMode="grid"
                                initialState={{
                                    showGlobalFilter: false,
                                    showColumnFilters: false,
                                }}
                                muiTablePaperProps={{
                                    sx: { backgroundColor: themeHelper.paper, color: themeHelper.text, backgroundImage: 'none', borderRadius: '12px' },
                                }}
                                muiTableContainerProps={{
                                    sx: { maxHeight: 'calc(100vh - 250px)', backgroundColor: themeHelper.paper },
                                }}
                                muiTopToolbarProps={{
                                    sx: { backgroundColor: themeHelper.paper, color: themeHelper.text },
                                }}
                                muiBottomToolbarProps={{
                                    sx: { backgroundColor: themeHelper.paper, color: themeHelper.text },
                                }}
                                muiTableHeadProps={{
                                    sx: { backgroundColor: themeHelper.paper, color: `${themeHelper.text} !important` },
                                }}
                                muiTableHeadCellProps={{
                                    sx: {
                                        padding: '4px', fontSize: '0.75rem', fontWeight: 'bold', whiteSpace: 'nowrap',
                                        backgroundColor: themeHelper.paper, color: `${themeHelper.text} !important`,
                                        borderBottom: `1px solid ${themeHelper.border}`,
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        padding: '5px', fontSize: '0.75rem', lineHeight: 2, whiteSpace: 'normal', wordBreak: 'break-word',
                                        backgroundColor: themeHelper.paper, color: themeHelper.text, borderBottom: `1px solid ${themeHelper.border}`,
                                    },
                                }}
                                muiTablePaginationProps={{
                                    rowsPerPageOptions: [100, 200, 400],
                                    variant: 'outlined',
                                    sx: darkMode ? {
                                        color: 'white',
                                        '& .MuiSelect-icon': { color: 'white' },
                                        '& .MuiTablePagination-select': { color: 'white' },
                                        '& .MuiTablePagination-selectLabel': { color: 'white' },
                                        '& .MuiTablePagination-displayedRows': { color: 'white' },
                                        '& .MuiPaginationItem-root': { color: 'white' },
                                        '& .MuiIconButton-root': { color: 'white' }
                                    } : {}
                                }}
                                renderRowActions={({ row }) => (
                                    <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                                        <Tooltip title="Gerenciar">
                                            <IconButton onClick={() => handleClickEdicao(row.original.id_ordem_servico ? { id_ordem_servico: row.original.id_ordem_servico, status_ordem: row.original.status } : row.original)}>
                                                <EditIcon style={{ color: 'green' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                            />
                        </Box>
                    )}
                </Box>
            )}
            {/* Diálogo do Resumo da Ronda Virtual (SNA) */}
            <Dialog
                open={openSnaRondaVirtual}
                onClose={handleCloseSnaRondaVirtual}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        backgroundColor: darkMode ? '#121212' : '#fff',
                        color: darkMode ? '#fff' : '#000'
                    }
                }}
            >
                <DialogContent>
                    <SNARonda
                        id_ronda_virtual={rondaVirtualSnaId}
                        darkMode={darkMode}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Tarefas;
